import { useEffect, useState } from 'react';
import { Accordion, Icon, Menu, Image, Label } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
import { Activity } from './../../../app/models/activity';
import { VideoIntelligenceData } from './videoIntelligence';

interface Props {
  groupedActivities: [string, Activity[]][];
  dropDownState: {
    activeIndex: number;
  };
  handleItemGroup: (
    e: any,
    data: any,
    itemGroupUpdate?: { id: string; title: string },
  ) => void;
}

// enum AssetDetails {
//   assetCleanedThisMonth = 'Asset Cleaned This Month',
//   currentMonthAssetCanMovement = 'Current Month Asset Can Movement',
//   deliveryAssetApproved = 'Delivery Asset Approved',
//   deliveryAssetPickerAssigned = 'Delivery Asset Picker Assigned',
//   deliveryOrdercreated = 'Delivery Order Created',
//   newAssetTitlesAddedInThisMonth = 'New Asset Added',
//   orderRegistered = 'Order Registered',
//   pendingReturnsFromBorrower = 'Pending Returns From Borrower',
//   readyfordelivery = 'Ready for delivery',
//   receivingOrderCreated = 'Receiving Order Created',
//   tagged = 'Tagged',
// }

export default function MediaAssetAccordionStandard({
  groupedActivities,
  dropDownState,
  handleItemGroup,
}: Props) {
  const [state, setState] = useState({
    activeIndex: dropDownState.activeIndex || 4,
  });
  const [itemGroupList, setItemGroupList] = useState<any[]>([]);
  const [activeItemGroup, setActiveItemGroup] = useState<boolean>(true);
  const { activeIndex } = state;
  const { activityStore, userStore, commonStore, dashboardStore } = useStore();

  useEffect(() => {
    const filteredData =
      userStore.user?.customerName === 'LVPCMS'
        ? activityStore.groupIdCountsDetails.filter((x) => {
            return x.title !== 'Film Festival';
          })
        : activityStore.groupIdCountsDetails;
    setItemGroupList(filteredData);
    // eslint-disable-next-line
  }, [activityStore.groupIdCountsDetails]);

  const handleClick = (_e: any, titleProps: any) => {
    const { index } = titleProps;
    const { activeIndex } = state;
    const newIndex = activeIndex === index ? -1 : index;
    setState({ activeIndex: newIndex });
  };

  const handleVideoIntelligence = (data: any) => {
    activityStore.videoIntelligenceAssetIdInfo(data?.AssetIds);
    setTimeout(() => {
      handleItemGroup(data, data);
      activityStore.peopleSelected = data;
      activityStore.peopleData = true;
    }, 100);
  };

  const allAssetsOnClick = async () => {
    activityStore.currentPage = 1;
    activityStore.Filter = '';
    activityStore.FilterById = '';
    activityStore.filterItem = '';
    activityStore.FilterCategory = '';
    activityStore.filteredAssetsCount =
      dashboardStore?.dashboard?.inventoryCount2 || 1;
    activityStore.searchAndItemGroupsAndFilter();
  };

  return (
    <Accordion styled style={{ width: '91vw' }}>
      {userStore.user?.email === 'demo.prasadcorp@gmail.com' && (
        <>
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={handleClick}
            style={{ backgroundColor: 'white', color: 'black' }}
          >
            <Icon name="dropdown" />
            People
          </Accordion.Title>
          <Accordion.Content
            style={{ backgroundColor: 'white', color: 'black' }}
            active={activeIndex === 0}
          >
            <Image.Group size="mini">
              {/* eslint-disable-next-line */}
              {VideoIntelligenceData.map((data) => {
                if (data.type === 'People') {
                  return (
                    <>
                      <Image
                        style={{
                          width: '50px',
                          height: '50px',
                        }}
                        onClick={() => handleVideoIntelligence(data)}
                        src={data.imageSrc}
                        onError={(img: any) =>
                          (img.target.src = '/assets/user.png')
                        }
                      />
                    </>
                  );
                }
              })}
            </Image.Group>
          </Accordion.Content>
          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={handleClick}
            style={{ backgroundColor: 'white', color: 'black' }}
          >
            <Icon name="dropdown" />
            Objects
          </Accordion.Title>
          <Accordion.Content
            style={{ backgroundColor: 'white', color: 'black' }}
            active={activeIndex === 1}
          >
            {/* eslint-disable-next-line */}
            {VideoIntelligenceData.map((data) => {
              if (data.type !== 'People') {
                return (
                  <>
                    {' '}
                    <Label
                      onClick={() => handleVideoIntelligence(data)}
                      style={{ margin: '5px 5px' }}
                    >
                      {data.image}
                    </Label>
                  </>
                );
              }
            })}
          </Accordion.Content>
        </>
      )}
      <Accordion.Title
        // active={activeIndex === 5}
        active={activeItemGroup}
        index={5}
        onClick={() => setActiveItemGroup(!activeItemGroup)}
        style={{ backgroundColor: 'white', color: 'black' }}
      >
        <Icon
          name="dropdown"
          // ItemGroup
        />
        {userStore?.user?.customerName === 'Museum'
          ? 'Department'
          : 'Item Group'}
      </Accordion.Title>
      <Accordion.Content
        style={{
          backgroundColor: 'white',
          color: 'black',
          maxHeight: '500px',
          overflowY: 'scroll',
        }}
        // active={activeIndex === 5}
        active={activeItemGroup}
      >
        <Menu vertical size="large" style={{ width: '100%' }}>
          <Menu.Item
            style={{
              fontSize: '14px',
              lineHeight: '18px',
              backgroundColor: activityStore.FilterById === '' ? '#e0e1e2' : '',
            }}
            content={
              userStore?.user?.customerName === 'Museum'
                ? 'All Departments'
                : 'All Item Groups'
            }
            onClick={(_e, data) =>
              handleItemGroup(_e, data, { id: '', title: '' })
            }
          />
          {itemGroupList?.map((fdata) => {
            return (
              <>
                <Menu.Item
                  style={{
                    fontSize: '14px',
                    lineHeight: '18px',
                    backgroundColor:
                      fdata.id === activityStore.FilterById ? '#e0e1e2' : '',
                  }}
                  key={fdata.id}
                  content={fdata.title}
                  onClick={(_e, data) => handleItemGroup(_e, data, fdata)}
                />
              </>
            );
          })}
        </Menu>
      </Accordion.Content>

      <Accordion.Title
        active={activeIndex === 4}
        index={4}
        onClick={handleClick}
        style={{ backgroundColor: 'white', color: 'black' }}
      >
        <Icon
          name="dropdown"
          //Filter
        />
        {
          (userLanguage[0].AssetViewItemLevelListPage?.AVIB01 as any)?.[
            `${commonStore.language.key}`
          ]
        }
      </Accordion.Title>
      <Accordion.Content
        style={{ backgroundColor: 'white', color: 'black' }}
        active={activeIndex === 4}
      >
        <Menu vertical size="large" style={{ width: '100%' }}>
          <Menu.Item
            style={{
              fontSize: '14px',
              lineHeight: '18px',
              backgroundColor:
                activityStore.FilterCategory === '' ? '#e0e1e2' : '',
            }}
            content={
              (userLanguage[0].AssetViewItemLevelListPage?.AVIB02 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            onClick={allAssetsOnClick}
          />
          {Object.entries(activityStore?.filterAssetsDetails || {})?.map(
            ([group, count]) =>
              count !== 0 ? (
                <>
                  {group === 'allAssets' || group === 'currentCount' ? (
                    <></>
                  ) : (
                    <Menu.Item
                      style={{
                        fontSize: '14px',
                        lineHeight: '18px',
                        backgroundColor:
                          activityStore.FilterCategory === group
                            ? '#e0e1e2'
                            : '',
                      }}
                      key={group}
                      content={`${[
                        `${
                          group.charAt(0).toUpperCase() +
                          group
                            .slice(1)
                            .replace(/([A-Z][a-z])/g, ' $1')
                            .trim()
                        }`,
                      ]} (${count})`}
                      // className={
                      //   (AssetDetails as any)?.[`${group}`] ===
                      //   activityStore.FilterCategory
                      //     ? `filterSelectedAssetDetailsItem`
                      //     : ``
                      // }
                      onClick={() => {
                        activityStore.currentPage = 1;
                        activityStore.peopleData = false;
                        activityStore.FilterCategory = group;
                        activityStore.filterMethod = 'filterCategory';
                        activityStore.filteredAssetsCount = count;
                        activityStore.setFilterCategoryString(group, count);
                      }}
                    />
                  )}
                </>
              ) : (
                <></>
              ),
          )}
        </Menu>
      </Accordion.Content>
    </Accordion>
  );
}
